module.exports = __webpack_public_path__ + "img/hourglass.591dd7b1.svg";